import React from "react";
import { Button, Modal, Font } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

type Props = {
  active: boolean;
  title?: string;
  body?: React.ReactNode | string;
  onClickCancel: () => void;
  onClickReconnect: () => void;
};

// 2023/02/02現在 再連携ボタンを京信専用の機能であるため、
// デフォルトの文言を京信用にしておくが、
// 今後の拡張性を考慮して、再連携ボタンの文言を外部から渡せるようにしておく
const TitleForKyoshin = "ビジネスバンキングの再連携";
const BodyForKyoshin = (
  <>
    <Font>
      連携済みのビジネスバンキングIDとの連携を解除して、新しいビジネスバンキングIDと連携します。
      <br />
      ビジネスバンキングIDが再発行されたなどの場合には、こちらからIDの再連携をしてください。
      <br />
      <br />
      現在のビジネスバンキングIDの連携を解除し、再連携に進みますか？
    </Font>
  </>
);

export const BizsolReconnectConfirmModal = ({
  active,
  title = TitleForKyoshin,
  body = BodyForKyoshin,
  onClickCancel,
  onClickReconnect,
}: Props) => {
  const addButton = (
    <>
      <Button type="button" variant="secondary" onClick={onClickCancel}>
        キャンセル
      </Button>
      <Button type="button" variant="destructive" onClick={onClickReconnect}>
        再連携
      </Button>
    </>
  );

  if (!active) {
    return <></>;
  }

  return (
    <div css={buttonWrapper}>
      <Modal
        title={title}
        body={body}
        zIndex={5}
        footerButtons={addButton}
        onClose={onClickCancel}
      />
    </div>
  );
};

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "30px",
  marginTop: "8px",
});
